import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-update-reload-page',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '',
})
export class AppUpdateReloadPageComponent {}
